import styled from '@xstyled/styled-components';
import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { select } from '~/lib/select';
import { Capsule } from '~/ui/capsules';
import { Chapter, Sequence, TrainingState, useTrainingStore } from '../state';
import { useTrainingUrl } from '../useTrainingUrl';
import { ItemTime } from './ItemTime';
import {
  SequenceStore,
  useSequenceStore
} from '~/training/sequence/SequenceStore';

const selector = (s: TrainingState) =>
  select(s, 'highestUnlockedPosition', 'toggleNav', 'skip');

const sequenceSelector = (s: SequenceStore) => select(s, 'clearBlocker');

const Wrapper = styled.divBox`
  display: grid;
  margin-bottom: md;
  grid-gap: 10px;
  grid-template-columns: auto 1fr auto;
  padding: sm md;
  border-radius: md;

  &:hover {
    background: ${p => p.theme.colors.greyLight};
    ${Capsule} {
      background: ${p => p.theme.colors.white};
      color: ${p => p.theme.colors.black};
      svg {
        stroke: ${p => p.theme.colors.black};
        fill: ${p => p.theme.colors.black};
      }
    }
  }

  &.active {
    background: ${p => p.theme.colors.accentDark};
    color: ${p => p.theme.colors.white};
    ${Capsule} {
      background: ${p => p.theme.colors.white};
      svg {
        stroke: ${p => p.theme.colors.black};
        fill: ${p => p.theme.colors.black};
      }
    }
    ${ItemTime} {
      color: ${p => p.theme.colors.white};
    }
  }
`;

export const ItemContainer: FC<{
  item: Chapter | Sequence;
  onClick: () => void;
  ariaExpanded: boolean;
}> = ({ item, children, ariaExpanded, onClick }) => {
  const url = useTrainingUrl();
  const { highestUnlockedPosition, toggleNav, skip } =
    useTrainingStore(selector);
  const { clearBlocker } = useSequenceStore(sequenceSelector);

  // TODO: revert this before go live!
  if (
    // eslint-disable-next-line no-constant-condition
    // true
    item.position <= highestUnlockedPosition ||
    skip
    // ||
    // environment === Environments.Dev
  ) {
    if (item.kind === 'chapter') {
      return (
        <Wrapper
          onClick={onClick}
          cursor="pointer"
          tabIndex={2}
          aria-expanded={ariaExpanded}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onClick();
            }
          }}
        >
          {children}
        </Wrapper>
      );
    } else {
      return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Wrapper
          ml="lg"
          as={NavLink}
          to={`${url}/${item.id}?disableAutoPlay=true`}
          onClick={() => {
            clearBlocker();
            setTimeout(() => toggleNav(false), 100);
          }}
          activeClassName="active"
          tabIndex={2}
        >
          {children}
        </Wrapper>
      );
    }
  } else {
    return (
      <Wrapper tabIndex={2} ml={item.kind === 'sequence' ? 'lg' : 0}>
        {children}
      </Wrapper>
    );
  }
};
